import React from 'react';

export default ({ message }) => {

  return (
      <p style={{ width:'200px' }}>
          {message}
      </p>
  );
};